import React from 'react'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/core/styles'
import {
  Box,
  Typography,
  useTheme,
} from '@material-ui/core'
import Tooltip from '../Tooltip'
import { getLevelArray } from '../utils'
import VariabilityWarning from '../VariabilityWarning/VariabilityWarning'
import _ from 'lodash'
import ProgressBar from '../ProgressBar'
import { interpolateRgbBasis } from 'd3'

// Styles for this component.
const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
    '& h3': {
      marginTop: 'auto',
      marginBottom: 'auto',
    },
  },
  ratingStack: {
    '& .variability-warning': {
      marginRight: theme.spacing(1),
    },
  },
  scoreChip: {
    width: 40,
    textAlign: 'end',
    marginLeft: 'auto',
  },
  levelChip: {
    width: 56,
    borderRadius: 2,
    textAlign: 'center',
    lineHeight: '18px',
    marginBottom: 'auto',
    '&.s0': {
      color: theme.extras.variables.colors.textDark,
      background: theme.extras.ratings.levelColors[0],
    },
    '&.s1': {
      color: theme.extras.variables.colors.textDark,
      background: theme.extras.ratings.levelColors[1],
    },
    '&.s2': {
      color: theme.extras.variables.colors.textDark,
      background: theme.extras.ratings.levelColors[2],
    },
    '&.s3': {
      color: theme.extras.variables.colors.white,
      background: theme.extras.ratings.levelColors[3],
    },
    '&.s4': {
      color: theme.extras.variables.colors.white,
      background: theme.extras.ratings.levelColors[4],
    },
  },
}))

export const LevelChip = ({ level }) => {
  const classes = useStyles()
  return (
    <Typography
      className={clsx(classes.levelChip, 's' + level)}
      variant="caption"
    >
      {getLevelArray()[Number(level)]}
    </Typography>
  )
}
export const ScoreChip = ({ score }) => {
  const classes = useStyles()
  const theme = useTheme()
  const scoreColorScale = interpolateRgbBasis(
    theme.extras.ratings.scoreColors,
  )

  return (
    <Box className={classes.scoreChip}>
      <ProgressBar
        color={scoreColorScale(score / 100)}
        ratio={score / 100}
      />
      <Typography variant="caption">{score}/100</Typography>
    </Box>
  )
}
export const RatingStack = ({
  score,
  level,
  index,
  variabilityLevel,
  activeGeoType,
}) => {
  const classes = useStyles()
  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      flexDirection="row"
      className={classes.ratingStack}
    >
      {!!variabilityLevel && (
        <VariabilityWarning
          variabilityLevel={variabilityLevel}
          metric={index}
          activeGeoType={activeGeoType}
          text=""
        />
      )}
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        flexDirection="column"
      >
        {!_.isNil(level) && <LevelChip level={level} />}
        {!_.isNil(score) && <ScoreChip score={score} />}
      </Box>
    </Box>
  )
}

/**
 * ie Education Index [ MEDIUM ]
 */
const IndexWithRating = ({
  index,
  name,
  score,
  level,
  variabilityLevel,
  activeGeoType,
  tooltipText,
  className,
}) => {
  const classes = useStyles()
  return (
    <Box
      className={clsx(
        classes.root,
        className,
        'index-with-rating',
      )}
    >
      <Typography variant="h3">
        {name}
        <Tooltip title={tooltipText} />
      </Typography>
      <RatingStack
        score={score}
        level={level}
        index={index}
        activeGeoType={activeGeoType}
        variabilityLevel={variabilityLevel}
      />
    </Box>
  )
}

export default IndexWithRating
